import request from './'

// Universal action supporting product groups, products and bundles
export const getItem = (id) => {
  return request({
    method: 'GET',
    url: `/api/boomerang/items/${id}`,
    params: {
      include: ['photo', 'bundle_items.product_group.products.photo', 'bundle_items.product.photo', 'products', 'products.photo']
    }
  })
}
